module.exports = __webpack_public_path__ + "img/Qualityserve-imga.76de8db7.png";